// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-project-dialog ::v-deep .ivu-modal-body {\n  padding: 20px;\n}\n.create-project-dialog ::v-deep .ivu-modal-footer {\n  padding: 0 18px 30px 18px !important;\n  margin-top: -65px;\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
